import { render, staticRenderFns } from "./ProfileCollab.vue?vue&type=template&id=3a671c3d&"
import script from "./ProfileCollab.vue?vue&type=script&lang=js&"
export * from "./ProfileCollab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports